"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ThemeProvider_1 = require("@material-ui/styles/ThemeProvider");
const light_1 = require("../../themes/light");
exports.Provider = (props) => {
    return React.createElement(ThemeProvider_1.default, Object.assign({ theme: light_1.LightTheme }, props));
};
exports.Provider.defaultProps = {
    theme: light_1.LightTheme
};
//# sourceMappingURL=Provider.js.map